import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  title: string,
 *  issue: string }} IssueDetails
 */

/**
 * @typedef {{
 *  requirements: IssueDetails[],
 *  projects: IssueDetails[] }} SubmitValidationResponse
 */

const api = new Api("api/municipalities");

/**
 * @param {number} municipalityId
 * @param {number} year
 * @returns {Promise<AxiosResponse<SubmitValidationResponse>>}
 */
export const getAnnualReportStatus = (municipalityId, year) =>
  api.get(`${municipalityId}/report/${year}`);

/**
 * @param {number} municipalityId
 * @param {number} year
 * @returns {void}
 */
export const submitAnnualReport = (municipalityId, year) =>
  api.post(`${municipalityId}/report/${year}`);
